import { render, staticRenderFns } from "./bigBanner.vue?vue&type=template&id=b81ac2c2&"
import script from "./bigBanner.vue?vue&type=script&lang=js&"
export * from "./bigBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports